import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const SelectContainer = styled.div`
  position: relative;
`;

const Dropdown = styled.div`
  position: absolute;
  width: 100%;
  border: 1px solid #ccc;
  background-color: #fff;
  max-height: 150px;
  border-radius: 14px;
  overflow-y: auto;
  z-index: 1;
`;

const Input = styled.input`
  width: 100%;
  padding: 15px;
  font-size: 16px;
  border-radius: 18px;
  border: 1px solid #ccc;
  box-sizing: border-box;
`;

const Option = styled.div`
  padding: 8px;
  cursor: pointer;
  line-height: 1.5;

  &:hover {
    background-color: var(--oligo-primary-color);
    color: #fff;
  }
`;

export const Select = ({
  options = [],
  initialValue,
  placeholder = 'Select...',
  onChange,
  ...others
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialValue ?? null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    onChange && onChange(option);
  };

  return (
    <SelectContainer ref={dropdownRef} {...others}>
      <div onClick={() => setIsOpen(!isOpen)}>
        <Input
          readOnly
          value={selectedOption || ''}
          placeholder={placeholder}
        />
      </div>

      {isOpen && (
        <Dropdown>
          {options.length > 0 ? (
            options.map((option, index) => (
              <Option
                key={index}
                selected={selectedOption === option}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </Option>
            ))
          ) : (
            <Option>No options found</Option>
          )}
        </Dropdown>
      )}
    </SelectContainer>
  );
};
